module.exports = __webpack_public_path__ + "img/banner.a1fc28f6.svg";